import {Injectable} from "@angular/core";
import {TareaDocumentoModel} from "../models/tarea-documento.model";
import {EvkHttpService, EvkMainFilterPage, EvkPageServiceBase, ResponsePage} from "@evomatik/evk-common";
import {Observable} from "rxjs";
import {EvkSecurityControlDataService} from "@evomatik/evk-seguridad";

@Injectable({providedIn: 'root'})
export class TareaDocumentoPageService extends EvkPageServiceBase<TareaDocumentoModel>{
    private filtro = {};
    constructor(
        public http: EvkHttpService,
        public mainFilter: EvkMainFilterPage,
        private evkSecurity: EvkSecurityControlDataService,
    ) {
        super(http, mainFilter);
        let username = this.evkSecurity.getUsuarioInfo().username;
        this.addFilter('usuarioEmisor',username);
        this.addFilter('usuarioReceptor',username);
        this.mainFilter.setOrder('created');
        this.mainFilter.setSort('desc');
    }
    get api(): string {
        return "/seaged-diligencias-service/tarea/page";
    }

    evkOnBeforePage(): Observable<any> {
        return new Observable<any>(observer => {
            observer.next();
        });
    }

    evkOnDonePage(response: ResponsePage<TareaDocumentoModel>): ResponsePage<TareaDocumentoModel> {
        return response;
    }
    get filters(): { [p: string]: string } {
        return this.filtro;
    }
    public addFilter(key, value) {
        if(value){
            this.filtro[key] = value;
        }
    }

    public deleteFilter(key) {
        delete this.filtro[key];
    }

    public deleteAllFilter() {
        this.filtro = {};
    }
}
